import { tenantHttp, type HttpClient } from './core/http-client';
import type { TeamInvite, TeamMember } from './models';

export class TeamService {
  constructor(private readonly http: HttpClient) {}

  list = () =>
    this.http.get<{ members: TeamMember[]; invitations: TeamInvite[] }>('/business/team');

  invite = (email: string, role: string) =>
    this.http.post('/business/team/invitations', { email, role });

  revokeInvite = (id: string) => this.http.delete(`/business/team/invitations/${id}`);

  changeRole = (id: string, role: string) =>
    this.http.patch(`/business/team/members/${id}`, { role });

  remove = (id: string) => this.http.delete(`/business/team/members/${id}`);
}

export const teamService = new TeamService(tenantHttp);
